<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    floating
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="val => $emit('update:is-drawer-open', val)"
  >
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
      <router-link
        to="/"
        class="d-flex align-center text-decoration-none"
      >
        <v-img
          :src="require('@/assets/images/logos/logo.png')"
          max-height="30px"
          max-width="30px"
          alt="logo"
          contain
          eager
          class="app-logo me-3"
        ></v-img>
        <v-slide-x-transition>
          <h2 class="app-title text--primary">
            {{ systemName }}
          </h2>
        </v-slide-x-transition>
      </router-link>
    </div>

        <!-- Navigation Items -->
    <v-list
      expand
      shaped
      class="vertical-nav-menu-items pr-5"
    >
      <!-- a family's panel is a list of children, not a list of screens: a
           parent with children at two schools has no school of their own -->
      <nav-menu-link
        :title="$t('my_children')"
        :to="{ name: 'my-children' }"
        icon="mdi-account-child-outline"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('where_is_the_bus')"
        :to="{ name: 'track-child' }"
        icon="mdi-bus-marker"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('attendance_history')"
        :to="{ name: 'child-history' }"
        icon="mdi-calendar-check-outline"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('alerts_and_absences')"
        :to="{ name: 'child-settings' }"
        icon="mdi-bell-outline"
      ></nav-menu-link>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiAccountCogOutline,
  mdiMapMarkerPath,
  mdiCrosshairsGps
} from '@mdi/js'
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'
import NavMenuGroup from './components/NavMenuGroup.vue'
import NavMenuLink from './components/NavMenuLink.vue'
import {Keys} from '/src/config.js'
import auth from '@/services/AuthService'

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
    Keys
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiMapMarkerPath,
        mdiCrosshairsGps
      },
      systemName: Keys.VUE_APP_SYSTEM_NAME
    }
  },
  data() {
        return {
            mode: null,
            //assumed done until told otherwise, so the link never flashes into
            //the menu of a school that finished setting up years ago
            setupComplete: true,
        }
    },
  mounted() {
    this.mode = auth.getMode()
    this.checkSetup()
  },
  methods: {
    /*
     * Whether there is anything left to set up.
     *
     * The answer is remembered once it is yes, because it cannot go back to no
     * - a school does not un-add its buses - and the menu is rebuilt on every
     * page, which would otherwise be one request per navigation forever.
     */
    checkSetup() {
      if (localStorage.setupComplete === "1") {
        return
      }

      this.setupComplete = false
      axios
        .get("/school-readiness/setup")
        .then(response => {
          this.setupComplete = !!response.data.complete
          if (this.setupComplete) {
            localStorage.setupComplete = "1"
          }
        })
        .catch(() => {
          //a menu is not the place to report a failed request
          this.setupComplete = true
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
